var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.55691V26.3482C0.0677107 28.1776 0.905353 29.9283 3.5111 30.0003H26.1268C27.0341 29.6299 27.2979 29.8268 28.1791 29.1852C30.4787 27.5116 29.9227 24.9746 29.9227 22.1335C29.9227 20.98 30.2285 17.4392 29.4809 16.7215C28.8168 16.084 27.7751 16.2975 27.3659 16.908C26.947 17.5331 27.1119 18.9185 27.1119 19.7336C27.1123 27.961 27.8762 27.1785 22.8525 27.1785L5.07672 27.1801C2.3721 27.1972 2.84957 26.0479 2.84957 23.6007V5.8674C2.8483 2.15792 2.74785 2.79002 11.6291 2.83283C14.1557 2.8452 13.8219 1.17314 13.429 0.601625C13.1089 0.136354 12.8895 0.216595 12.4667 0.000610352H3.85888C1.15744 0.214058 0.238418 1.05833 0 3.55722L0 3.55691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9784 7.59943C29.9863 5.91849 30.0474 4.2052 29.9205 2.52839C29.733 0.0488424 29.0762 0.104662 27.6905 0H18.9863C18.3938 0.35934 17.7745 0.518554 17.8766 1.5934C18.0756 3.68855 21.4757 2.49128 24.9303 2.86045C22.802 4.8928 20.4588 7.56645 18.3391 9.63115L11.5264 16.4351C10.6373 17.3568 10.5721 18.3742 11.5019 18.9194C12.8584 19.7146 14.4319 17.4586 15.9429 15.9052L27.4858 4.33207C27.654 5.92737 26.6179 10.3162 27.3224 11.5328C27.8472 12.4393 29.3747 12.4133 29.807 11.3416C30.0108 10.8373 29.98 8.32318 29.9784 7.59911V7.59943Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_1118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.03b8e172beb0e395b75aee593e6d6b1f.svg";
export { ForwardRef as ReactComponent };